module.exports = __webpack_public_path__ + "img/3var.50caca3d.png";